module.exports = __webpack_public_path__ + "img/style_3_pl.24bff813.jpeg";